(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pulse-contact"]) return;
  try {
    
/* Country combobox for the contact form. One instance per [data-pcs-combo]. The options are
   real <li role="option"> elements rendered server-side (Liquid loops localization.available_countries),
   so the script only filters, navigates and commits; it never builds the list. Posts the country
   NAME in the hidden field so the ticket reads plainly. */
(function () {
  document.querySelectorAll('[data-pcs-combo]').forEach(function (root) {
    var input = root.querySelector('[data-pcs-combo-input]');
    var list = root.querySelector('[data-pcs-combo-list]');
    var value = root.querySelector('[data-pcs-combo-value]');
    var err = root.querySelector('[data-pcs-combo-err]');
    var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    var form = root.closest('form');
    var active = -1;
    var visible = [];

    function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

    function filter(q) {
      q = norm(q.trim());
      var starts = [], words = [], within = [];
      opts.forEach(function (o) {
        var n = norm(o.textContent);
        if (!q) starts.push(o);
        else if (n.indexOf(q) === 0) starts.push(o);
        else if (n.split(/[\s-]+/).some(function (w) { return w.indexOf(q) === 0; })) words.push(o);
        else if (n.indexOf(q) >= 0) within.push(o);
      });
      visible = starts.concat(words, within);
      opts.forEach(function (o) { o.hidden = visible.indexOf(o) < 0; o.classList.remove('is-active'); });
      visible.forEach(function (o) { list.appendChild(o); });   /* re-order: best matches first */
      setActive(visible.length && q ? 0 : -1);
    }

    function setActive(i) {
      if (active >= 0 && visible[active]) visible[active].classList.remove('is-active');
      active = i;
      if (active >= 0 && visible[active]) {
        visible[active].classList.add('is-active');
        input.setAttribute('aria-activedescendant', visible[active].id);
        var o = visible[active], top = o.offsetTop, bot = top + o.offsetHeight;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (bot > list.scrollTop + list.clientHeight) list.scrollTop = bot - list.clientHeight;
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function open() { list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); }

    function commit(o) {
      input.value = o.textContent.trim();
      value.value = input.value;
      input.setAttribute('aria-invalid', 'false');
      err.hidden = true;
      close();
    }

    function settle() {                 /* on leaving the field: exact text match commits, anything else clears the value */
      var q = norm(input.value.trim());
      var hit = opts.filter(function (o) { return norm(o.textContent) === q; })[0];
      if (hit) commit(hit); else { value.value = ''; close(); }
    }

    input.addEventListener('focus', function () { filter(input.value); open(); });
    input.addEventListener('click', function () { if (list.hidden) { filter(input.value); open(); } });
    input.addEventListener('input', function () { value.value = ''; filter(input.value); open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) { filter(input.value); open(); } setActive(Math.min(active + 1, visible.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter') { if (!list.hidden && active >= 0) { e.preventDefault(); commit(visible[active]); } else if (!list.hidden) { e.preventDefault(); settle(); } }
      else if (e.key === 'Escape') { if (!list.hidden) { e.preventDefault(); close(); } }
      else if (e.key === 'Tab') { settle(); }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });   /* keep focus on the input */
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) commit(o);
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) settle(); });

    if (form) form.addEventListener('submit', function (e) {
      settle();
      if (!value.value) {
        e.preventDefault();
        err.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', err.id);
        input.focus();
      }
    });
  });
})();

/* Live chat: shipped offline. The column flips to online only when our own chat
   widget (snippets/pulse-chat.liquid, 2026-10-15; it replaced the Gorgias embed
   this used to probe) has loaded and reports itself online, and the button opens
   it. With the widget switched off in Theme settings the column reads offline. */
(function () {
  var col = document.querySelector('[data-pcs-chat]');
  if (!col) return;
  var off = col.querySelector('[data-pcs-chat-off]'), on = col.querySelector('[data-pcs-chat-on]'), btn = col.querySelector('[data-pcs-chat-open]');
  function setOnline(v) { col.setAttribute('data-pcs-chat', v ? 'on' : 'off'); if (off) off.hidden = !!v; if (on) on.hidden = !v; }
  function probe() { var c = window.PulseChat; setOnline(!!(c && c.online)); }
  if (btn) btn.addEventListener('click', function () { try { if (window.PulseChat && typeof window.PulseChat.open === 'function') window.PulseChat.open(); } catch (e) {} });
  probe();
  window.addEventListener('pulse-chat-ready', probe);
  window.addEventListener('pulse-chat-status', function (e) { setOnline(!!(e.detail && e.detail.online)); });
})();

/* Prefill from the order-confirmation email's "Change or cancel this order" link
   (2026-09-03, spec in preview/email/PORT-NOTES.md): /pages/contact?order=1042&topic=cancel
   puts the order number in its field and, for topic=cancel, writes the one-line
   request into the message, so the customer only presses Send. Country still
   prefills from the market. Nothing is submitted here. */
(function () {
  var q;
  try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
  var order = (q.get('order') || '').replace(/^#/, '').replace(/[^A-Za-z0-9-]/g, '').slice(0, 20);
  var topic = (q.get('topic') || '').toLowerCase();
  var orderEl = document.getElementById('pcs-order');
  var bodyEl = document.getElementById('pcs-body');
  if (orderEl && order && !orderEl.value) orderEl.value = order;
  if (bodyEl && topic === 'cancel' && !bodyEl.value) {
    bodyEl.value = 'I would like to '; // Andre, 2026-10-11 23:02: change OR cancel, so the customer finishes the sentence
  }
})();

  } catch(e) { console.error(e); }
})();
})();
